module.exports = "../../app/cells/pages/contest/menu_bar_float_cell.rb";